import { SchemaBrowserType } from 'js/constants/schemaEditor';
import { map, filter, includes, isEmpty } from 'lodash';
import React from 'react';
import RecipeBuilderGrid from '../RecipeBuilderGrid';
import SelectAllAttrsCheckbox from '../SelectAllAttrsCheckbox';
import { SaveSchemaSpec } from '../SaveSchemaSpec';

const Grid = ({
  schema,
  samples,
  rawSchema = null,
  rawSamples = null,
  outputSchema,
  allowSaving = false,
}) => {
  const outputSchemaAttrNames = map(outputSchema, '__txName');
  const unmappedSchema = filter(
    schema,
    ({ __txName }) => !includes(outputSchemaAttrNames, __txName),
  );
  const saveButton = allowSaving && <SaveSchemaSpec schema={rawSchema} samples={rawSamples} />;

  return (
    <>
      <div className="schema-spec-selector-description">
        {isEmpty(unmappedSchema) ? (
          <div className="save-schema-spec-button-container">
            <div>All Attributes Mapped.</div>
            {saveButton}
          </div>
        ) : (
          <>
            <b>Unmapped Attributes from the selected schema</b>
            <div className="save-schema-spec-button-container">
              <div>
                <SelectAllAttrsCheckbox
                  gridId={SchemaBrowserType.SCHEMA_SPEC}
                  schema={unmappedSchema}
                />
                Select All
              </div>
              {saveButton}
            </div>
          </>
        )}
      </div>
      <RecipeBuilderGrid
        gridId={SchemaBrowserType.SCHEMA_SPEC}
        allowSelection
        schema={unmappedSchema}
        samples={samples}
        showCharacteristics={false}
        hideExpandMetaToggle
      />
    </>
  );
};

export default Grid;
